import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Form, Grid } from 'semantic-ui-react';
import { bindActionCreators } from 'redux';
import * as settlementAction from 'actions/settlement';

class SettlementForm extends Component {
  handleChange = async (e, data) => {
    const { settlementAPI } = this.props;
    await settlementAPI.tradingList({ year: data.value });
  };

  render() {
    const { trading } = this.props;

    return (
      <Form className="top-form" style={{ marginBottom: '10px' }}>
        <Grid>
          <Grid.Row className="form-row">
            <Grid.Column width={16}>
              {trading && trading.data ? (
                <Form.Group style={{ marginBottom: 0 }}>
                  <Form.Field inline className="com-sikdae-group">
                    <Dropdown
                      selection
                      value={trading.data.currentSearchYear}
                      options={trading.data.searchYearList}
                      onChange={this.handleChange}
                    />
                  </Form.Field>
                </Form.Group>
              ) : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

SettlementForm = connect(
  (state) => ({
    trading: state.settlement.tradingList
  }),
  (dispatch) => ({
    settlementAPI: bindActionCreators(
      {
        tradingList: settlementAction.SettlementTradingList
      },
      dispatch
    )
  })
)(SettlementForm);

export default SettlementForm;
